// packages imports
import { Divider, Grid, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

// components imports
import { CustomController } from '../../../common/CustomController'
import CheckboxController from '../../../common/CheckboxController'
import { BillingType } from '../../../../../generated'
import { useEffect } from 'react'

const InterestForm = () => {
  const { watch, setValue } = useFormContext()
  const writeOffInterest = watch('billing.writeOffInterest')
  const billingType = watch('billing.billingType')
  const secondTierRate = watch('billing.interestRates[1].rate')
  const increaseInterestRateOnFirstLatePayment = watch('billing.increaseInterestRateOnFirstLatePayment')

  useEffect(() => {
    if (billingType === BillingType.Contingency || billingType === BillingType.ContingencyHybrid) {
      setValue('billing.writeOffInterest', true)
    }
  }, [billingType, setValue])

  if (billingType === BillingType.Contingency || billingType === BillingType.ContingencyHybrid) return null

  return (
    <Grid container item spacing={2.5}>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" textTransform="uppercase" fontWeight={700}>
          Interest
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <CheckboxController
          name="billing.writeOffInterest"
          label="Don't charge Interest on this Matter"
          sx={{ mt: -1 }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <CustomController
          fieldType="number"
          controllerName="billing.interestRates[0].rate"
          controllerLabel="Interest (%)"
          isDisabled={writeOffInterest}
          sx={{ my: 0 }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CustomController
          fieldType="number"
          controllerName="billing.interestRates[0].applicableDays"
          controllerLabel="Applicable No. of Days"
          isDisabled={writeOffInterest || increaseInterestRateOnFirstLatePayment}
          sx={{ my: 0 }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CustomController
          fieldType="number"
          controllerName="billing.interestRates[1].rate"
          controllerLabel="Interest (%)"
          isDisabled={writeOffInterest}
          sx={{ my: 0 }}
        />
      </Grid>

      {billingType === BillingType.FlatFee && secondTierRate > 0 && (
        <Grid item xs={12}>
          <CheckboxController
            name="billing.increaseInterestRateOnFirstLatePayment"
            label={`Increase interest rate to ${secondTierRate}% after first late payment`}
            disabled={writeOffInterest}
            sx={{ mt: -1 }}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default InterestForm
